import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.LossCodeCategory.Save.IRequest;
type Response = Api.Core.LossCodeCategory.Save.IResponse;
type Headers = Api.Core.LossCodeCategory.Save.IHeaders;
const url = '/api/Claims/LossCodeCategory';
export default async function lossCodeCategorySaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
